import { render } from "./ReplyBox.vue?vue&type=template&id=1b69ee0f"
import script from "./ReplyBox.vue?vue&type=script&lang=js"
export * from "./ReplyBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__